import { Tabs } from "@shared/ui/tabs";
import { AlertCircle } from "lucide-react";
import React, { useState } from "react";
import {
  useBillCycleMeterReadingMissing,
  useMeterReadingPendingValidation,
} from "../../hooks";
import { MissingReadingsSubTab } from "./MissingReadingsSubTab";
import { PendingValidationSubTab } from "./PendingValidationSubTab";

interface IssuesTabProps {
  billCycleId: string;
  billDraftId: string;

  onSelectionChange?: (selectedRows: any[]) => void;
}

export const IssuesTab: React.FC<IssuesTabProps> = ({
  billCycleId,
  billDraftId,
  onSelectionChange,
}) => {
  const { data: missingReadingsData } = useBillCycleMeterReadingMissing(
    billCycleId,
    billDraftId,
    1
  );
  const { data: pendingValidationData } = useMeterReadingPendingValidation(
    billCycleId,
    billDraftId,
    1
  );

  console.log("debug id and data", billCycleId, missingReadingsData);
  const issuesTabComponents = {
    "missing-readings": {
      label: "Missing Readings",
      icon: <AlertCircle className="h-4 w-4" />,
      count: missingReadingsData?.count || 0,
      component: (
        <MissingReadingsSubTab
          onSelectionChange={onSelectionChange}
          meterReadingMissingList={missingReadingsData}
          billDraftId={billDraftId}
        />
      ),
    },
    "pending-validation": {
      label: "Pending Validation",
      icon: <AlertCircle className="h-4 w-4" />,
      count: pendingValidationData?.count || 0,
      component: (
        <PendingValidationSubTab
          meterReadingPendingValidationList={pendingValidationData}
        />
      ),
    },
  };
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <div className="space-y-4">
      <div className="border rounded-md overflow-hidden">
        <Tabs
          tabComponents={issuesTabComponents}
          defaultValue="missing-readings"
          urlMapping={{
            "missing-readings": "missing",
            "pending-validation": "validation",
          }}
          tabsListClassName="w-full grid grid-cols-2 bg-muted/30 p-1"
          idPrefix="issues-tab"
          disableUrlSync={true}
        />
      </div>
    </div>
  );
};
